import { statusAeroOptions } from './SelectorMapping';

/** Sincroniza D_Vto CALMA ↔ I_Vto 0 (misma lógica que WeatherSelectors). */
export const normalizeWindFieldsForForm = (
    windDirection?: string | null,
    windSpeed?: string | number | null
): { windDirection: string | null; windSpeed: string | null } => {
    const speed =
        windSpeed === null || windSpeed === undefined || windSpeed === ''
            ? null
            : String(windSpeed);

    if (windDirection === 'CALMA' || speed === '0') {
        return { windDirection: 'CALMA', windSpeed: '0' };
    }

    return {
        windDirection: windDirection ?? null,
        windSpeed: speed,
    };
};

const AUTO_OBSERVATION_PATTERNS = [
    /\s*\.?\s*Anillado:\s*[^.]*\.?/gi,
    /\s*\.?\s*Estado aerogenerador:\s*[^.]*\.?/gi,
    /\s*\.?\s*Se solicitó parada del aerogenerador\.?/gi,
];

export const formatRiskDetectedLabel = (value: unknown): string => {
    if (value === true || value === 1 || value === '1' || value === 'true') {
        return 'Si';
    }
    return 'No';
};

const normalizeObservationText = (text: string): string =>
    text
        .replace(/\.\s*\./g, '.')
        .replace(/^\.\s*/, '')
        .replace(/\s*\.\s*$/, '')
        .trim();

const dedupeSentences = (text: string): string => {
    const sentences = text
        .split(/\.+/)
        .map((sentence) => sentence.trim())
        .filter(Boolean);

    const seen = new Set<string>();
    const unique: string[] = [];

    sentences.forEach((sentence) => {
        const key = sentence.toLowerCase();
        if (!seen.has(key)) {
            seen.add(key);
            unique.push(sentence);
        }
    });

    if (unique.length === 0) {
        return '';
    }

    return `${unique.join('. ')}.`;
};

const stripAutoObservationSuffixes = (anillado?: string | null): string => {
    let text = (anillado || '').trim();
    if (!text) {
        return '';
    }

    AUTO_OBSERVATION_PATTERNS.forEach((pattern) => {
        text = text.replace(pattern, '');
    });

    return normalizeObservationText(text);
};

export const formatCensusLineObservations = (line: {
    anillado?: string | null;
    aero_status?: string;
    aeroOnComments?: string;
    askStop?: string;
    askAnillado?: string;
}): string => {
    const userText = stripAutoObservationSuffixes(line?.anillado);
    const parts: string[] = [];

    if (userText) {
        parts.push(userText);
    }

    if (line?.aero_status === 'apagado' && line?.aeroOnComments) {
        const aeroLabel =
            statusAeroOptions.find((option) => option.value === line.aeroOnComments)?.label ||
            line.aeroOnComments;
        const fragment = `Estado aerogenerador: ${aeroLabel}`;
        if (!parts.some((part) => part.toLowerCase().includes('estado aerogenerador'))) {
            parts.push(fragment);
        }
    }

    if (line?.askStop === 'yes') {
        const fragment = 'Se solicitó parada del aerogenerador';
        if (!parts.some((part) => part.toLowerCase().includes('se solicitó parada'))) {
            parts.push(fragment);
        }
    }

    if (parts.length === 0) {
        const fallback = dedupeSentences(normalizeObservationText(line?.anillado || ''));
        return fallback || '-';
    }

    return dedupeSentences(parts.join('. '));
};
